/* assets/section-product-tabbed-features.js */
(() => {
  'use strict';

  const SECTION_SEL = '.product-tabbed-features';

  function pauseVideos(root) {
    root.querySelectorAll('video').forEach((video) => {
      try {
        video.pause();
      } catch (e) {
        /* noop */
      }
    });
  }

  function playActiveVideo(panel) {
    if (!panel) return;
    const video = panel.querySelector('video');
    if (!video) return;
    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function scrollTabIntoView(tabsWrap, tab) {
    if (!tabsWrap || !tab) return;
    const wrapRect = tabsWrap.getBoundingClientRect();
    const tabRect = tab.getBoundingClientRect();
    const overflowLeft = tabRect.left < wrapRect.left + 8;
    const overflowRight = tabRect.right > wrapRect.right - 8;
    if (overflowLeft || overflowRight) {
      tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  function switchTab(root, index) {
    const tabs = root.querySelectorAll('.product-tabbed-features__tab');
    const panels = root.querySelectorAll('.product-tabbed-features__panel');
    const tabsWrap = root.querySelector('.product-tabbed-features__tabs-wrap');

    if (!tabs.length || !panels.length) return;

    const nextIndex = Math.max(0, Math.min(index, tabs.length - 1));

    pauseVideos(root);

    tabs.forEach((tab, i) => {
      const isActive = i === nextIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel, i) => {
      const isActive = i === nextIndex;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    scrollTabIntoView(tabsWrap, tabs[nextIndex]);
    playActiveVideo(panels[nextIndex]);
  }

  function onKeydown(event, root) {
    const tabs = Array.from(root.querySelectorAll('.product-tabbed-features__tab'));
    if (!tabs.length) return;

    const current = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    let next = current;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = (current + 1) % tabs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = (current - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    switchTab(root, next);
    tabs[next].focus();
  }

  function init(root) {
    if (!root || root.dataset.ptfReady === 'true') return;
    root.dataset.ptfReady = 'true';

    const tabs = root.querySelectorAll('.product-tabbed-features__tab');
    if (!tabs.length) return;

    root._ptfOnClick = (event) => {
      const tab = event.target.closest('.product-tabbed-features__tab');
      if (!tab || !root.contains(tab)) return;
      const index = Array.from(tabs).indexOf(tab);
      if (index < 0) return;
      switchTab(root, index);
    };

    root._ptfOnKeydown = (event) => {
      const tab = event.target.closest('.product-tabbed-features__tab');
      if (!tab || !root.contains(tab)) return;
      onKeydown(event, root);
    };

    root.addEventListener('click', root._ptfOnClick);
    root.addEventListener('keydown', root._ptfOnKeydown);

    const activePanel = root.querySelector('.product-tabbed-features__panel.is-active');
    playActiveVideo(activePanel);
  }

  function destroy(root) {
    if (!root) return;
    pauseVideos(root);
    if (root._ptfOnClick) {
      root.removeEventListener('click', root._ptfOnClick);
      delete root._ptfOnClick;
    }
    if (root._ptfOnKeydown) {
      root.removeEventListener('keydown', root._ptfOnKeydown);
      delete root._ptfOnKeydown;
    }
    delete root.dataset.ptfReady;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SECTION_SEL).forEach(init);
  }

  function destroyAll(scope) {
    (scope || document).querySelectorAll(SECTION_SEL).forEach(destroy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyAll(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest(SECTION_SEL);
    if (!root) return;
    const panel = event.target.closest('.product-tabbed-features__panel');
    if (!panel) return;
    const panels = Array.from(root.querySelectorAll('.product-tabbed-features__panel'));
    const index = panels.indexOf(panel);
    if (index >= 0) switchTab(root, index);
  });
})();
